export const formatSsn = (ssn: string) => {
  const cleanSsn = ssn.replace(/\D/g, '').slice(0, 13);

  const groups = cleanSsn.match(/^(\d{0,3})(\d{0,4})(\d{0,4})(\d{0,2})$/).slice(1);
  const formattedSsn = groups.filter(Boolean).join('.');

  return formattedSsn;
}